module.exports = __webpack_public_path__ + "static/media/BannerRegistroMobileEN.043cbead.jpg";